import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openProfileDrawer } from 'store/auth/authSlice';
import st from "./style.module.css";

import starCoins from "assets/images/app/coins.svg";
import dollarCoins from "assets/images/app/dollar-coins.png";
import infoPic from "assets/images/app/info-circle.svg";
import schoolPic from "assets/images/app/school.svg";
import score from "assets/images/app/score.svg";
import RankingDrawer from "components/rankingDrawer";
import { openPaiementDrawer } from "store/chat/mainSlice";

/* import belgiumFlag from "assets/images/app/belgium-flag.png"; */
/* import frenchFlag from "assets/images/app/french-flag.png"; */
/* import moroccoFlag from "assets/images/app/morocco-flag.png"; */


const UserNavBar: React.FC = () => {

    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.auth);
    const [type, setType] = useState<string>("");

    const openDrawer = () => dispatch(openProfileDrawer());

    const openPaiementStudentDrawer = () => {
        dispatch(openPaiementDrawer());
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener('resize', handleResize);

    const [rakingDrawerVisible, setRakingDrawerVisible] = useState(false);
    const showRakingDrawer = (rankType: string) => {
        setType(rankType);
    };

    const onCloseRankingDrawer = () => {
        setType("");
    };

    useEffect(() => {
        if (type !== "") {
            setRakingDrawerVisible(true);
        }
        else {
            setRakingDrawerVisible(false);
        }
    }, [type, rakingDrawerVisible]);

    return (
        <>
            <div className={st.navbar}>
                {user?.rankEtab !== undefined && user?.etablissement !== "Autre établissement" && <div className={st.infoBoxHoverSchool}>
                    <div className={st.infoColumn} onClick={() => showRakingDrawer("school")}>
                        <div className={st.left}><img src={schoolPic} height={isMobile ? 10 : 15} className={st.leftText}></img> Rank<img src={infoPic} height={10} className={st.infoPic}></img></div>
                        <div className={st.right}>{user?.rankEtab}<span className={st.classementInfo}>{user?.rankEtab === 1 ? "er" : "e"}</span></div>
                    </div>
                </div>}
                {/* {user?.rankNational !== undefined && <div className={st.infoBoxHoverNat}>
                    <div className={st.infoColumn} onClick={() => showRakingDrawer("national")}>
                        <div className={st.left}><img src={schoolPic} height={isMobile ? 10 : 15} className={st.leftText}></img> Pays<img src={infoPic} height={10} className={st.infoPic}></img></div>
                        <div className={st.right}>{user?.rankNational}<span className={st.classementInfo}>{user?.rankNational === 1 ? "er" : "e"}</span></div>
                    </div>
                </div>} */}
                <div className={st.userNavInfoBox}>
                    <div className={st.userNavBox}>
                        <div className={st.infoBox}>
                            <div className={st.info}>
                                <div className={st.left}><img src={starCoins} height={isMobile ? 10 : 12} className={st.leftText}></img> Coins</div>
                                <div className={st.right}>{user?.points}<span className={st.coinsInfo}>CNS</span><img src={infoPic} height={10} className={st.infoPic}></img></div>
                            </div>
                        </div>
                        <div className={st.infoBox}>
                            <div className={st.info}>
                                <div className={st.left}><img src={score} height={isMobile ? 10 : 12} className={st.leftText}></img> Score</div>
                                <div className={st.right}>{user?.score}<span className={st.coinsInfo}>PTS</span><img src={infoPic} height={10} className={st.infoPic}></img></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={st.infoBoxSolde}>
                    <div className={st.infoColumn} onClick={() => openPaiementStudentDrawer()}>
                        <div className={st.left}><img src={dollarCoins} height={isMobile ? 10 : 15} className={st.leftText}></img> Solde<img src={infoPic} height={10} className={st.infoPic}></img></div>
                        <div className={st.right}>{user?.coins}<span className={st.coinsInfo}>EUR</span></div>
                    </div>
                </div>
            </div>
            <RankingDrawer visible={rakingDrawerVisible} onClose={onCloseRankingDrawer} user={user} type={type} />
        </>
    );
};

export default UserNavBar;